import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import InputMask from 'react-input-mask';
import ReactBnbGallery from 'react-bnb-gallery'
import 'react-bnb-gallery/dist/style.css'
import DownstairsPlan from "./floorPlan/DownstairsPlan";
import FirstFloorPlan from "./floorPlan/FirstFloorPlan";
import TentPlan from "./floorPlan/TentPlan";

interface IFormProps {
  places: object,
  selected_places: object,
  from: string,
  to: string,
  group_size: number,
  loadCart: any,
  session_id: any,
  churchpersonnumber: number,
  underage_people_count: number

}
interface MyStates {
  ajaxLoaded: boolean,
  spinner: string,
  places: object,
  selected_places: object,
  galleryOpened: boolean,
  capacity: number
  photos: [],
  sumplaces:number,
  tentplaces: number

}
export default class PlacesList extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    let selected_places = {}
    let capacity = 0;
    Object.keys(this.props.selected_places).map((i) => {
      let p = this.props.selected_places[i]
      selected_places[p.id] = p
      capacity += p.capacity
    })

    let sumplaces = 0;
    Object.keys(this.props.places).filter((num) =>this.props.places[num].storey != 'tent_site').map((i) => {
      let p = this.props.places[i]
      sumplaces += p.capacity
    })

    let tentplaces = 0;
    Object.keys(this.props.places).filter((num) =>this.props.places[num].storey == 'tent_site').map((i) => {
      let p = this.props.places[i]
      tentplaces += p.capacity
    })


    this.state = {
      ajaxLoaded: true,
      spinner: 'none',
      places: this.props.places,
      selected_places: selected_places,
      galleryOpened: false,
      photos: [],
      capacity: capacity,
      sumplaces: sumplaces,
      tentplaces: tentplaces

    }


    this.toggleGallery = this.toggleGallery.bind(this);

  }

  toggleGallery(gallery) {
    this.setState(prevState => ({
      photos: gallery,
      galleryOpened: !prevState.galleryOpened
    }));
  }


  private remove(id, date){
    swal({
        title: "Biztos, hogy törli ezt a tételt a listáról?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {

          var ajax = new Ajax(window.location.origin+ '/api/ordering/removePlaceFromCart');
          ajax.doPost({id: id, date: date}).then((response) => {
            if( response.status !== undefined && response.status === 'success' ){
              swal({
                title: response.message,
                icon: "success",
              });
            } else {
              swal({
                title: "Hiba történt!",
                text: response.message,
                icon: "error",
              });
            }
            this.props.loadCart()
          })

        }
    });
  }

  private chose(id){

    if((this.props.group_size - this.state.capacity > 0) || (this.state.selected_places[id] !== undefined)){
      var ajax = new Ajax(window.location.origin+ '/api/ordering/addPlaceToCart');
      ajax.doPost({
        session_id: this.props.session_id,
        place_id: id,
        from: this.props.from,
        to: this.props.to,
        group_size: this.props.group_size,
        underage_people_count: this.props.underage_people_count,
        churchpersonnumber: this.props.churchpersonnumber

      }).then((response) => {
        if( response.status !== undefined && (response.status === 'success' || response.status === 'retractation' )){
          swal({
            title: response.message,
            icon: "success",
          });
        } else {
          swal({
            title: "Hiba történt!",
            text: response.message,
            icon: "error",
          });
        }
        this.props.loadCart()
      })
    }else{
      swal({
        title: "Hiba történt!",
        text: "Nincs szükség több foglalásra!",
        icon: "error",
      });
    }
  }

  private datecheck(){
    if(
      this.props.from !== undefined && this.props.from !== null && this.props.from !== '' &&
      this.props.to !== undefined && this.props.to !== null && this.props.to !== ''
     ){
      return (<>A megadott időpontban nem található szállás!</>)
     } else {
       return (<>Válasszon időpontot először!</>)
     }
  }

  public Rooms(storey){
    let rooms = [];
    let rooms_ids = [];
    Object.keys(this.state.places).map((i) => {
      let place = this.state.places[i]
      if(storey == place.storey){
          rooms.push(this.Room(place));
          rooms_ids.push(place.id);
      }
    });

    if(rooms.length == 0){
      return;
    }

    return (
       <>
        <div className = "row">
          <div className="col-md-6">
            { storey == 'downstairs' &&  <DownstairsPlan rooms_ids={rooms_ids}/> }
            { storey == 'first_floor' &&  <FirstFloorPlan rooms_ids={rooms_ids} /> }
            { storey == 'tent_site' &&  <TentPlan rooms_ids={rooms_ids} />}

          </div>
          <div className="col-md-6">
            {rooms}
          </div>
        </div>
        <hr/>
        </>
    );
  }

  public Room(place){
    return (
        <>
          <div className="row place" key={'placeitem_' + place.id}>
            <div className="col-md-2 img">
              <img style={{cursor:'pointer'}} onClick={() => this.toggleGallery(place?.['gallery'])} src={'/'+place?.['main_image']} />
              <ReactBnbGallery
                  show={this.state.galleryOpened}
                  photos={this.state.photos}
                  onClose={() => this.toggleGallery(place?.['gallery'])} />
            </div>
            <div className="col-md-10">
              <h3>{place?.['name']}</h3>
              <p>{place?.['description']}</p>
              <div className="row">
                <div className="col-sm-6">
                  <div className="bed">férőhely: {place?.capacity ?? '-'} fő</div>
                </div>
                <div className="col-sm-6">
                  { this.state.selected_places[place?.id] !== undefined?
                      <button type="button" className="btn btn-success btn-block" onClick={() => this.chose(place?.id)}>Kiválasztva</button>
                      :
                      <button type="button" className="btn btn-primary btn-block" onClick={() => this.chose(place?.id)}>Kiválasztom</button>
                  }
                </div>
              </div>
            </div>
            <div style={{clear: 'both'}}></div>
          </div>
        </>
    )
  }

  public render() {



    if ( Object.keys(this.state.places).length > 0 ) {
      return (
          <>
            <div className="row" style = {{display: 'flex', justifyContent: 'center'}}>
              <div style ={{width: 'auto', marginRight: '15px', marginBottom: '10px', background: '#febf0f', color: '#fff'}} className="form-control pull-right">
                <i className="fa fa-bed"></i> Elérhető férőhely: {this.state.sumplaces} fő
              </div>
              <div style ={{width: 'auto', marginRight: '15px', marginBottom: '10px', background: 'rgba(24,23,23,0.38)', color: '#fff'}} className="form-control pull-right">
                <i className="fa fa-bed"></i> Elérhető sátorhely: {this.state.tentplaces} fő
              </div>
              <div style ={{width: 'auto', marginRight: '15px', marginBottom: '10px', background: '#17a2b8', color: '#fff'}} className="form-control pull-right">
                <i className="fa fa-bed"></i> Elhelyezendő létszám: {this.props.group_size - this.state.capacity > 0 ? this.props.group_size - this.state.capacity : 0} fő
              </div>
            </div>

          <div className = "row">
            <div className = "col-md-6"><h4 className={"text-center"}><b>Alaprajz</b></h4></div>
            <div className = "col-md-6"><h4 className={"text-center"}><b>Szállások részletei</b></h4></div>
          </div>
          {this.Rooms('downstairs')}
          {this.Rooms('first_floor')}
          {this.Rooms('tent_site')}
        </>
      )
    } else {
      return (<>{this.datecheck()}</>)
    }
  }

  private getPriceFormat(price){

    if( price == 0 ){
      return (
        <div className="price">Díjtalan</div>
      )
    } else {
      return (
        <div className="price">{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Ft</div>
      )
    }
  }
}